import { ConsultUserBasicInfo } from '../model/vo/consult';

/**
 * 시퀀셜 상담 회원 판정 — HSMALL-17244
 *
 * 정회원(한샘몰 일반 가입, simpleUserFlag 'N')만 true.
 * 간편회원(소셜/애플, 'Y')·비회원·회원정보 미로드(undefined)는 모두 false →
 * 이름·번호 직접 입력 + 휴대폰 점유인증 대상.
 * 로그인 여부(isAuthenticated)로 면제를 가르던 기존 분기를 대체한다.
 * (TS-001~004)
 */
export const isRegularMember = (
  userInfo?: Pick<ConsultUserBasicInfo, 'simpleUserFlag'> | null,
): boolean => userInfo?.simpleUserFlag === 'N';
